module.exports = __webpack_public_path__ + "img/web3.a6f76ed1.png";